export default __webpack_public_path__ + "static/media/thinRed.d9d4f8be.svg";